/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

import DesignSystemHeading from '@atlaskit/heading';

import { useProductContext } from '../product-context';

const marketingHeadingStyles = css({
	// eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors
	'& *': {
		// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
		fontFamily:
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
			'"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif !important',
	},
});

export const Heading = ({
	...rest
}: React.ComponentProps<typeof DesignSystemHeading>): JSX.Element => {
	const { product } = useProductContext();
	if (product === 'marketing') {
		return (
			<div css={marketingHeadingStyles}>
				<DesignSystemHeading {...rest} />
			</div>
		);
	}
	return <DesignSystemHeading {...rest} />;
};
